import { ProvisioningProfile } from '@models/provisioning-profile.model';
import { User } from '@models/user.model';
import { WdaProfile } from '@models/wda-profile.model';
import { UserService } from '@services/user.service';

export const mapUserDetails = async (
  profiles: WdaProfile[] | ProvisioningProfile[],
) => {
  const uniqueUserIds = new Set();
  profiles.forEach((profile) => {
    uniqueUserIds.add(profile.createdById);
    if (profile.updatedById) {
      uniqueUserIds.add(profile.updatedById);
    }
  });
  const userIds = Array.from(uniqueUserIds);
  if (userIds.length > 0) {
    const users = await UserService.findAll(`id@${userIds.join('#')}`);
    profiles.forEach((profile) => {
      profile.updatedBy = users.content.find(
        (user: User) => user.id === profile.updatedById,
      );
      profile.createdBy = users.content.find(
        (user: User) => user.id === profile.createdById,
      );
    });
  }
};
